import {useState, Dispatch, SetStateAction} from "react";
import {isNil, isFunction} from "lodash";
import {LocalStorageWrapper} from "../helpers";

type Options = {
  encrypted?: boolean;
};

export const useLocalStorageState = <S>(
  key: string,
  initialState: S | (() => S),
  options: Options = {encrypted: true}
): [S, Dispatch<SetStateAction<S>>] => {
  const [item, setInnerValue] = useState<S>(() => {
    if (options.encrypted) {
      const valueItem = LocalStorageWrapper.get(key);
      if (!isNil(valueItem)) {
        return valueItem;
      }
    } else {
      const valueItemString = localStorage.getItem(key);
      if (!isNil(valueItemString)) {
        return JSON.parse(valueItemString);
      }
    }
    return isFunction(initialState) ? initialState() : initialState;
  });

  const setValue = (value: SetStateAction<S>): void => {
    setInnerValue((currentInnerValue) => {
      const valueToStore = isFunction(value) ? value(currentInnerValue) : value;

      if (!isNil(valueToStore)) {
        if (options.encrypted) {
          LocalStorageWrapper.set(key, valueToStore);
        } else {
          localStorage.setItem(key, JSON.stringify(valueToStore));
        }
      } else {
        if (options.encrypted) {
          LocalStorageWrapper.remove(key);
        } else {
          localStorage.removeItem(key);
        }
      }

      return valueToStore;
    });
  };

  return [item, setValue];
};
